module.exports = __webpack_public_path__ + "src/assets/img/vinnieIcon.18219e61.svg";